import './App.css';
import React from "react"
import AddingTask from "./AddingTask";


function App() {

    return (
      <div>
          <AddingTask/>
      </div>
  );
}

export default App;
